class DetailsListElement extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", this);
  }

  handleEvent(e) {
    const summary = e.target.closest("summary");
    if (!summary) return;
    const details = summary.closest("details");
    if (!details || !this.contains(details)) return;
    e.preventDefault();
    if (details.open) {
      this.#close(details);
    } else {
      const name = details.getAttribute("name");
      if (name) {
        this.querySelectorAll(`details[name="${name}"][open]`).forEach((sibling) => {
          this.#close(sibling);
        });
      }
      this.#open(details);
    }
  }

  #open(details) {
    details._anim?.cancel();
    const from = details.offsetHeight;
    details.open = true;
    const to = details.offsetHeight;
    details._anim = details.animate(
      [{ height: from + "px" }, { height: to + "px" }],
      { duration: 300, easing: "ease" }
    );
  }

  #close(details) {
    details._anim?.cancel();
    details.classList.add("exit");
    const from = details.offsetHeight;
    details.open = false;
    const to = details.offsetHeight;
    details.open = true;
    details._anim = details.animate(
      [{ height: from + "px" }, { height: to + "px" }],
      { duration: 300, easing: "ease", fill: "forwards" }
    );
    details._anim.onfinish = () => {
      details.open = false;
      details.classList.remove("exit");
      details._anim.cancel();
    };
  }
}

customElements.define("details-list", DetailsListElement);
